import { render, staticRenderFns } from "./all-author.vue?vue&type=template&id=d026335c&scoped=true"
import script from "./all-author.vue?vue&type=script&lang=js"
export * from "./all-author.vue?vue&type=script&lang=js"
import style0 from "./all-author.vue?vue&type=style&index=0&id=d026335c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d026335c",
  null
  
)

export default component.exports